import React from 'react';
import { usePopup } from '@/hooks/use-popup';

/**
 * Technical Specs based on computed styles:
 * - Card Shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
 * - Card Background: #ffffff
 * - Vertical Text Color: #000, opacity 0.8
 * - Vertical Text Size: 2.5rem
 * - Primary Color: #323992 (Deep corporate blue)
 */

const VirtualTour = () => {
  const videoThumbnail = "https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/images/videos-20.jpg";
  const { openPopup } = usePopup();

  return (
    <section
      id="videos"
      className="section-card rounded-0 border-0 shadow mb-[3rem] bg-white relative overflow-hidden"
      style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)' }}>

      <div className="card-body p-4 md:p-10 flex flex-col lg:flex-row min-h-[400px]">
        {/* Mobile Header */}
        <div className="lg:hidden mb-6">
          <h2 className="text-[24px] font-medium text-[#212529] opacity-80 border-b border-[#dee2e6] pb-2">Virtual Tour</h2>
        </div>

        {/* Main Content Area */}
        <div className="flex-grow pr-0 lg:pr-12 order-2 lg:order-1">
          {/* Video Placeholder Container */}
          <div 
            onClick={openPopup}
            className="relative group cursor-pointer w-full aspect-video md:aspect-[21/9] overflow-hidden mt-10"
          >
            <img
              src={videoThumbnail}
              alt="Abhee Celestial City Virtual Tour Thumbnail"
              className="w-full h-full object-cover object-bottom transition-transform duration-500 group-hover:scale-105" />

            
          </div>
        </div>

        {/* Vertical Section Title (Visible on Desktop) */}
        <div className="hidden lg:flex items-center justify-center border-l border-[#dee2e6] pl-6 ml-auto order-1 lg:order-2">
          <div className="vertical-text whitespace-nowrap select-none">
            Virtual Tour
          </div>
        </div>
      </div>

      <style jsx>{`
        .vertical-text {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          font-size: 2.5rem;
          font-weight: 400;
          color: #000;
          opacity: 0.8;
          font-family: var(--font-sans);
        }
      `}</style>
    </section>);

};

export default VirtualTour;